import { Injectable } from '@angular/core';
import { IFlagFeature } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

@Injectable()
export class HideBackButtonFromLastStep implements IFlagFeature {
  name = Features.HIDE_BACK_BUTTON_FROM_LAST_STEP;

  public isEnabled(container: any): boolean {
    return container[this.name].isEnabled();
  }
}
